import React from "react";
import "./promotionModal.css";
import CryptoJS from "crypto-js";
import { Link } from "react-router-dom";
import * as apiUtil from "../../../../util/apiUtil";
import * as tokenUtil from "../../../../util/tokenUtil";

// 로컬 스토리지 키
const PROMO_INDEX_KEY = "PROMO_MODAL_INDEX";
const SOURCE_GENERAL = "GENERAL";
const SOURCE_ACADEMY = "ACADEMY";
const SOURCE_MESSAGE_PANG = "MESSAGE_PANG";
const SOURCE_CHERO = "CHERO";
const SOURCE_HOST = "HOST";
const SOURCE_NAVER_DA = "NAVER_DA";
const SOURCE_NAVER_SA = "NAVER_SA";

// 매체별(ACADEMY/CHERO/MESSAGE_PANG/NAVER_DA/NAVER_SA/GENERAL) 도입문의 폼 URL은 더 이상 하드코딩하지 않고
// 어드민 "유입 링크 관리 > 매체 관리"에서 설정한 값을 /api/common/ad-source/inquiry-form-urls 에서 가져온다.
// HOST(호스팅사 연동: 카페24/솔라피/메이크샵)는 매체 코드가 아니라 hostType 기반 별도 버킷이라 그대로 둔다.
const LINK_HOST = "https://docs.google.com/forms/d/e/1FAIpQLSehRRgzq77lw7tK2foAoF2s7WzO51qoMBomLFdM3_yacGrYxw/viewform?usp=pp_url&entry.1561815768=%ED%98%B8%EC%8A%A4%ED%8C%85+%EC%82%AC(%EC%B9%B4%ED%8E%98+24...)";

class PromotionModal extends React.Component {
    constructor(props) {
        super(props);

        const items = props.items || [];
        this.items = items;

        this.state = {
            isOpen: false,
            hideToday: false,
            currentIndex: 0,
            currentImageSrc: items[0]?.imageSrc || "",
            promotionSource: SOURCE_GENERAL,
            formLinks: {},
        };
    }

    componentDidMount() {
        if (this.props.enabled === false || this.items.length === 0) {
            return;
        }

        // 매체별 도입문의 폼 URL(어드민 "유입 링크 관리 > 매체 관리"에서 설정)을 가져온다.
        apiUtil.asyncRequest({
            url: "/api/common/ad-source/inquiry-form-urls",
            method: apiUtil.requestMethod.GET,
            success: (result) => {
                if (result && typeof result === 'object') {
                    this.setState({ formLinks: result });
                }
            },
        });

        const hiddenDate = localStorage.getItem("PROMO_MODAL_HIDE_DATE");
        const today = this.getTodayString();

        if (hiddenDate === today) {
            this.setState({ isOpen: false });
        } else {
            let currentIdx = parseInt(localStorage.getItem(PROMO_INDEX_KEY) || '0', 10);
            if (Number.isNaN(currentIdx) || currentIdx < 0) {
                currentIdx = 0;
            }
            currentIdx = currentIdx % this.items.length;

            const nextIdx = (currentIdx + 1) % this.items.length;

            const imageToShow = this.items[currentIdx]?.imageSrc || "";

            localStorage.setItem(PROMO_INDEX_KEY, nextIdx.toString());

            this.setState({
                isOpen: true,
                currentIndex: currentIdx,
                currentImageSrc: imageToShow,
            });
        }

        this.setPromotionLink();
    }

    setPromotionLink() {
        // 1. hstate 체크 (sessionStorage, AES 복호화) - 학원 유입 여부 확인
        try {
            const encryptedHstate = window.sessionStorage.getItem('hstate');

            if (encryptedHstate) {
                const hstateStr = encryptedHstate.replace(/ /g, '+');
                const decryptedBytes = CryptoJS.AES.decrypt(decodeURIComponent(hstateStr), process.env.REACT_APP_AES_ENCRYPT_KEY);
                const hstate = JSON.parse(decryptedBytes.toString(CryptoJS.enc.Utf8));
                if (hstate && hstate.hostType === 'A') {
                    this.setState({ promotionSource: SOURCE_ACADEMY });
                    return;
                } else if (hstate && hstate.hostType === 'MP') {
                    this.setState({ promotionSource: SOURCE_MESSAGE_PANG });
                    return;
                } else if (hstate && (hstate.hostType === 'C' || hstate.hostType === 'M' || hstate.hostType === 'S' )) {
                    this.setState({ promotionSource: SOURCE_HOST });
                    return;
                } else if (hstate && hstate.hostType === 'CHERO') {
                    this.setState({ promotionSource: SOURCE_CHERO });
                    return;
                }
            }
        } catch (e) {
            // hstate 복호화 실패 시 무시
        }

        // 2. 로그인 상태라면 유저 정보 API로 hostType 조회
        if (tokenUtil.getAccessToken()) {
            apiUtil.asyncRequest({
                url: "/api/bizchat/user/info/host",
                method: apiUtil.requestMethod.POST,
                success: (result) => {
                    if (result?.hostType === 'ACADEMY' || result?.adSource === 'ACADEMY') {
                        this.setState({ promotionSource: SOURCE_ACADEMY });
                    } else if (result?.hostType === 'CHERO' || result?.adSource === 'CHERO') {
                        this.setState({ promotionSource: SOURCE_CHERO });
                    } else if (result?.hostType === 'MESSAGE_PANG' || result?.adSource === 'MESSAGE_PANG') {
                        this.setState({ promotionSource: SOURCE_MESSAGE_PANG });
                    } else if (result?.hostType === 'CAFE24' || result?.hostType === 'SOLAPI' || result?.hostType === 'MAKESHOP') {
                        this.setState({ promotionSource: SOURCE_HOST });
                    } else if (result?.adSource === 'NAVER_SA') {
                        this.setState({ promotionSource: SOURCE_NAVER_SA });
                    } else if (result?.adSource === 'NAVER_DA') {
                        this.setState({ promotionSource: SOURCE_NAVER_DA });
                    } else {
                        this.applyAdSrcLink();
                    }
                },
            });
            return;
        }

        // 3. adSrc 기반 링크 설정
        this.applyAdSrcLink();
    }

    applyAdSrcLink() {
        try {
            const adSrc = sessionStorage.getItem('adSrc');
            if (adSrc) {
                // 공백을 +로 치환 (URL 디코딩 이슈 대응)
                let replacedAdSrc = adSrc.replace(/ /g, '+');

                // Base64 Decode (UTF-8 지원)
                const decodedString = decodeURIComponent(
                    atob(replacedAdSrc).split('').map(function (c) {
                        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
                    }).join('')
                );

                const decryptedAdSrc = JSON.parse(decodedString);

                if (decryptedAdSrc && decryptedAdSrc.adPath) {
                    if (decryptedAdSrc.adPath === 'CHERO') {
                        this.setState({ promotionSource: SOURCE_CHERO });
                        return;
                    } else if (decryptedAdSrc.adPath === 'MESSAGE_PANG') {
                        this.setState({ promotionSource: SOURCE_MESSAGE_PANG });
                        return;
                    } else if (decryptedAdSrc.adPath === 'NAVER_DA') {
                        this.setState({ promotionSource: SOURCE_NAVER_DA });
                        return;
                    } else if (decryptedAdSrc.adPath === 'NAVER_SA') {
                        this.setState({ promotionSource: SOURCE_NAVER_SA });
                        return;
                    }
                }
            }
        } catch (e) {
            // adSrc 파싱 실패 시 무시
        }
        this.setState({ promotionSource: SOURCE_GENERAL });
    }

    componentWillUnmount() {
        // 롤링 로직이 아니므로 타이머 해제 불필요
    }

    getTodayString() {
        return new Date().toISOString().slice(0, 10);
    }

    handleCheck = (e) => {
        this.setState({ hideToday: e.target.checked });
    };

    closeModal = () => {
        if (this.state.hideToday) {
            const today = this.getTodayString();
            localStorage.setItem("PROMO_MODAL_HIDE_DATE", today);
        }

        this.setState({ isOpen: false });
    };

    getCurrentLink = () => {
        const { currentIndex, promotionSource, formLinks } = this.state;
        const currentItem = this.items[currentIndex] || {};

        if (currentItem.linkMode === "legacy") {
            // HOST는 매체 코드가 아닌 hostType 기반 별도 버킷이라 그대로 하드코딩 값을 쓴다.
            if (promotionSource === SOURCE_HOST) return LINK_HOST;
            return formLinks[promotionSource] || formLinks[SOURCE_GENERAL] || "";
        }

        if (currentItem.linkMode === "static") {
            return currentItem.defaultUrl || "";
        }

        if (currentItem.linkMode === "bySource" && currentItem.sourceUrls && currentItem.sourceUrls[promotionSource]) {
            return currentItem.sourceUrls[promotionSource];
        }

        return currentItem.defaultUrl || "";
    };

    render() {
        if (!this.state.isOpen) return null;

        const { currentImageSrc, currentIndex } = this.state;
        const currentItem = this.items[currentIndex] || {};
        const currentLink = this.getCurrentLink();
        const imageAlt = currentItem.alt || "프로모션 이미지";
        const openInNewTab = currentItem.openInNewTab !== false;

        return (
            <div className="promo-backdrop">
                <div className="promo-modal">
                    <button className="promo-close-btn" onClick={this.closeModal}>×</button>

                    <div className="promo-image-wrap">
                        {!currentLink ? (
                            <img
                                src={currentImageSrc}
                                alt={imageAlt}
                                className="promo-image"
                            />
                        ) : !openInNewTab && currentLink.startsWith('/') ? (
                            <Link to={currentLink}>
                                <img
                                    src={currentImageSrc}
                                    alt={imageAlt}
                                    className="promo-image"
                                    style={{ cursor: 'pointer' }}
                                />
                            </Link>
                        ) : (
                            <a
                                href={currentLink}
                                target={openInNewTab ? "_blank" : undefined}
                                rel={openInNewTab ? "noopener noreferrer" : undefined}
                            >
                                <img
                                    src={currentImageSrc}
                                    alt={imageAlt}
                                    className="promo-image"
                                    style={{ cursor: 'pointer' }}
                                />
                            </a>
                        )}
                    </div>

                    <div className="promo-actions-container">
                        <div className="promo-checkbox-wrap">
                            <input
                                type="checkbox"
                                id="hideToday"
                                checked={this.state.hideToday}
                                onChange={this.handleCheck}
                            />
                            <label htmlFor="hideToday">오늘 하루 이 창 보지 않기</label>
                        </div>

                        <div className="promo-footer">
                            <button className="promo-normal-btn" onClick={this.closeModal}>
                                닫기
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default PromotionModal;
